module.exports = __webpack_public_path__ + "static/photo-hosting-ef89b87694a3243bd7863e0e82038b4f.jpg";